// This should be included on all apps so it will bring in all global
// colours, as well as import the typefaces from the one spot. This should
// eventually act as a reset or a baseline stylesheet for every app.
import { createGlobalStyle } from 'styled-components';

import { cssColors } from '../constants/colors';
import { cssSizes } from '../constants/sizes';

export const GlobalStyle = createGlobalStyle`
  :root {
    ${cssColors}
    ${cssSizes}
    --primary-font-family: 'primarytypeface', serif;
    --secondary-font-family: 'secondarytypeface', serif;
    --tertiary-font-family: 'tertiarytypeface', serif;
    --body-font-family: system-ui, sans-serif;
  }
  @font-face {
    font-family: primarytypeface;
    src: url('https://d1mviimjnzagon.cloudfront.net/fonts/sayidoprimary-medium/v1/sayidoprimary-medium.eot');
    src: url('https://d1mviimjnzagon.cloudfront.net/fonts/sayidoprimary-medium/v1/sayidoprimary-medium.eot?#iefix') format("embedded-opentype"), url('https://d1mviimjnzagon.cloudfront.net/fonts/sayidoprimary-medium/v1/sayidoprimary-medium.woff2') format("woff2"), url('https://d1mviimjnzagon.cloudfront.net/fonts/sayidoprimary-medium/v1/sayidoprimary-medium.woff') format("woff"),url("https://d1mviimjnzagon.cloudfront.net/fonts/sayidoprimary-medium/v1/sayidoprimary-medium.ttf") format("truetype");
    font-weight: 400;
    font-display: swap;
  }
  @font-face {
    font-family: secondarytypeface;
    src: url('https://d1mviimjnzagon.cloudfront.net/fonts/sayidoprimary-regular/v1/sayidoprimary-regular.woff2') format("woff2"), url('https://d1mviimjnzagon.cloudfront.net/fonts/sayidoprimary-regular/v1/sayidoprimary-regular.woff') format("woff");
    font-weight: normal;
    font-display: swap;
  }
  @font-face {
    font-family: tertiarytypeface;
    src: url('https://d1mviimjnzagon.cloudfront.net/fonts/sayidoprimary-light/v1/sayidoprimary-light.woff2') format("woff2"), url('https://d1mviimjnzagon.cloudfront.net/fonts/sayidoprimary-regular/v1/sayidoprimary-regular.woff') format("woff");
    font-weight: normal;
    font-display: swap;
  }
  @font-face {
    font-family: 'bodytypeface';
    font-style: normal;
    font-weight: 400;
    src: url('https://fonts.gstatic.com/s/raleway/v19/1Ptug8zYS_SKggPNyC0IT4ttDfA.woff2') format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
    font-display: swap;
  }
  body {
    font-family: var(--body-font-family);
    line-height: 1.35;
  }
  a {
    color: var(--link-text-color);
    text-decoration: none;
    cursor: pointer;
  }
  a:hover {
    text-decoration: none;
  }
`;
